<template>
  <el-dialog title="详情" :width="'98%'" :visible.sync="dialogFormVisible" :close-on-click-modal="true" @close="$emit('input',false)">
    <CustomTool :show-filter="false" :show-refresh="true" :show-time-area="false" :show-time="false" :show-time-text="false" :show-export="true" @filters="refresh" @export="exportExcelPerformanceDetail"/>
    <div v-show="false" style="display:flex;margin-left: 20px;margin-bottom: 20px;">
      <div v-for="(filterConent,idx) in filterRequestData.queryCond">
        {{column_mapper[filterConent.columnName].split(':')[0]}}:{{filterConent.columnValue}}
        <span v-if="idx!==filterRequestData.queryCond.length-1">、</span>
      </div>
    </div>

    <div style="height: 100%;padding:20px 40px;overflow: scroll;background:#f5f7fa;">
      <el-row v-for="(rowItem,rowIdx) in contentItems" :gutter="40">
        <el-col v-for="columnItem in rowItem" :span="24/contentItems[rowIdx].length">
          <CustomCardTable :card-data="columnItem" :filterRequestData="filterRequestData" :needRefresh="refreshId" @row-click="rowClick"/>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import CustomCardTable from "@/component/PrePayManage/dialog/CustomCardTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import {exportExcel, exportPerformanceDetail, exportProjectDetail} from "@/api/api";
export default {
  name: "CustomDialog",
  components:{
    CustomCardTable,
    CustomTool
  },
  props:{
    column_mapper:{
      type:Object
    },
    filterRequestData:{
      type:Object
    },
    value:{
      type: Boolean,
      default:false,
      required: true
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      refreshId:0,
      contentItems:[
        [
          {
            key:"project",
            loading:true,
            height:620,
            title:"订单明细",
            type:"card",
            custom:true,//自定义表头k
            //后台自定义
            showColoums: [
              // {
              //   prop: "project_id",
              //   label: "订单ID:varchar"
              // },
              // {
              //   prop: "project_name",
              //   label: "订单名称::varchar",
              // },
              // {
              //   prop: "quotation_type",
              //   label: "计价类型:varchar",
              // },
              // {
              //   prop: "business_type",
              //   label: "业务类型:varchar",
              // },
              //
              // {
              //   prop: "responsible_p_dept",
              //   label: "部门:varchar",
              // },
              // {
              //   prop: "responsible_s_dept",
              //   label: "业务组:varchar",
              // },
              // {
              //   prop:"ateam",
              //   label: "销售组:varchar"
              // },
              //
              // {
              //   prop:"client_name",
              //   label: "客户:varchar"
              // },
              // {
              //   prop: "account_manager",
              //   label: "客户经理:varchar",
              // },
              // {
              //   prop: "project_manager",
              //   label: "项目经理:varchar",
              // },
              //
              // {
              //   prop: "project_status",
              //   label: "执行状态:varchar",
              // },
              // {
              //   prop: "settlement_status",
              //   label: "结算状态:varchar",
              // },
              // {
              //   prop: "project_stage",
              //   label: "项目阶段:varchar",
              // },
              //
              // {
              //   prop: "amount",
              //   label: "金额:decimal",
              // }
            ],
            tableData:[]
            //     {//自定义表的数据结构
            //   column_comment:{},//名称映射表
            //   data:[],//数据源头
            //   field_list:[]//表头顺序
            // },
          }
        ]
      ]
    };
  },

  watch:{
    value(newVal){
      this.dialogFormVisible = newVal
      if(this.dialogFormVisible){
        this.refresh()
      }
    }
  },
  methods:{
    refresh(content){
      this.refreshId +=1
    },

    rowClick(e){
      // console.log('rowClick', e['project_name'])
      this.$store.commit("setProjectId", e["project_id"]);
      this.$store.commit("setProjectInfo", {
        projectId: e["project_id"],
        projectName: e["project_name"],
        accu: 0
      })
      this.dialogFormVisible = false
    },
    async exportExcelPerformanceDetail(){
      let param = {
        ...this.filterRequestData
      }
      // console.log('exportPerformanceDetail/param',param)
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportProjectDetail(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        const fileName = (this.filterRequestData.advance_name?this.filterRequestData.advance_name:"预付款") + '-' + Y + M + D + H + m + s + ".xlsx"
        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    }
  }
}
</script>

<style scoped>

</style>
